window.onload = function() {
  
        function isMobile() {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        }
        
        function isTablet() {
            return /iPad|Android|tablet/i.test(navigator.userAgent);
        }
        
        document.addEventListener("DOMContentLoaded", () => {
            document.addEventListener("variant:changed", () => {});
        
            if ((isMobile() || isTablet()) && location.pathname + location.search === "/pages/promotions?app") {
                ["header", "footer", "#shopify-section-top-bar", "#shopify-section-toolbar_mobile", "#t4s-heading-page", "#whatsapp-chat-widget-container"]
                    .forEach(selector => document.querySelector(selector)?.style.setProperty("display", "none", "important"));
                document.querySelector(".t4s-section-inner.t4s-container-wrap")?.removeAttribute("style");
            }

            // document.querySelectorAll(".cpnbtn").forEach(btn => {
            //     btn.addEventListener("click", () => {
            //         navigator.clipboard.writeText(btn.value);
            //         btn.textContent = "COPIED";
            //         setTimeout(() => { btn.textContent = "COPY"; }, 3000);
            //     });
            // });
        });
       
// Get the input field and the results element
const searchInput = document.querySelector('.t4s-search-header__form-inner');
const results = document.querySelector('.t4s-frm-search__results');

// Function to toggle visibility
function toggleResults(visible) {
    if (visible) {
        results.style.opacity = '1';
        results.style.visibility = 'visible';
        results.style.pointerEvents = 'auto';
    } else {
        results.style.opacity = '0';
        results.style.visibility = 'hidden';
        results.style.pointerEvents = 'none';
    }
}

// Show results when the input field is clicked
searchInput.addEventListener('click', function(event) {
    // Prevent the event from bubbling up (so it doesn't immediately hide)
    event.stopPropagation();
    toggleResults(true);
});

// Hide results if clicked outside of the input or results
document.addEventListener('click', function(event) {
    if (!searchInput.contains(event.target) && !results.contains(event.target)) {
        toggleResults(false);
    }
});


  
// ready funciton ending below

  
}
